import { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error module not typed
import { getEmail } from 'conversations-internal-schema/connected-email-account/operators/connectedEmailAccountGetters';
import { getCheckConnectedAccounts } from 'conversations-thread-data/channel-configuration/public/operators';
import { isGenericChannelId } from 'conversations-thread-data/channel-configuration/public/types';
// @ts-expect-error module not typed

// TODO: move to composer-ui
import { ChannelCapabilitiesConfigContext } from 'conversations-thread-view/channel-capabilities/context/ChannelCapabilitiesConfigContext';
import { useHydratedChannelInstanceOptions } from '../hooks/useHydratedChannelInstanceOptions';
import FromEmailOption from './FromEmailOption';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const ChannelInstanceSelect = ({
  inboxId,
  value,
  onChange,
  defaultSendFromEnabled
}) => {
  const {
    capabilitiesBlob,
    genericChannelId: editorConfigurationKey
  } = useContext(ChannelCapabilitiesConfigContext);
  const checkConnectedAccounts = Boolean(getCheckConnectedAccounts(capabilitiesBlob));
  const isValidGenericChannelId = editorConfigurationKey && isGenericChannelId(editorConfigurationKey);
  const genericChannelId = isValidGenericChannelId ? editorConfigurationKey : null;
  const {
    connectedAccounts,
    instanceOptions,
    loadingData
  } = useHydratedChannelInstanceOptions({
    inboxId,
    genericChannelId,
    checkConnectedAccounts,
    defaultSendFromEnabled
  });
  const handleChange = useCallback(({
    target: {
      value: nextValue
    }
  }) => {
    const nextConnectedAccount = connectedAccounts && connectedAccounts.find(account => {
      const connectedEmail = getEmail(account);
      return connectedEmail && connectedEmail.toLowerCase() === nextValue.toLowerCase();
    });
    onChange(nextValue, nextConnectedAccount);
  }, [connectedAccounts, onChange]);
  return /*#__PURE__*/_jsx(Select, {
    disabled: !isValidGenericChannelId,
    buttonUse: "transparent",
    isLoading: loadingData,
    onChange: handleChange,
    options: instanceOptions,
    value: value,
    itemComponent: FromEmailOption,
    "data-selenium-test": "metadata-from-input"
  });
};
ChannelInstanceSelect.displayName = 'ChannelInstanceSelect';
ChannelInstanceSelect.propTypes = {
  inboxId: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.string
};
export default ChannelInstanceSelect;